module.exports = __webpack_public_path__ + "static/media/Report.e43a7fc2.svg";